
export default {
  props: {
    post: {
      type: Object,
      default: null
    }
  },
  vessel: {
    meta: {
      paddingY: 'xs',
      textTransform: 'uppercase',
      fontSize: 'sm'
    }
  }
}
